var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1515 3.84825C19.879 3.57691 19.5554 3.36224 19.1995 3.21666C18.8435 3.07108 18.4623 2.99746 18.0777 3.00007C17.6931 3.00267 17.3129 3.08144 16.959 3.23183C16.605 3.38222 16.2844 3.60124 16.0156 3.87625L4.41596 15.4759L3 20.9997L8.52383 19.583L20.1235 7.98333C20.3986 7.71464 20.6177 7.3941 20.7681 7.04022C20.9185 6.68634 20.9973 6.30615 20.9999 5.92163C21.0025 5.53711 20.9289 5.15589 20.7833 4.80001C20.6376 4.44412 20.4229 4.12064 20.1515 3.84825V3.84825Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6844 4.20825L19.7915 8.31533",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41675 15.4751L8.52782 19.579",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.35ebcb35eb4ad776b141255577123d01.svg";
export { ForwardRef as ReactComponent };